<template>

  <div v-if="message.user == this.$root.user.uid" class="message mine">
    <span class="time" v-if="!continuedMessage">{{ dateFormat(message.createdAt, 'h:MMtt') }}</span>
    <span class="date" v-if="!continuedMessage">{{ dateFormat(message.createdAt, 'ddd dS mmm') }},</span>
    <p class="bubble">{{ message.content }}</p>
    <div class="author" v-if="!finalMessage">
      <span class="author-name">{{ from.firstname + ' ' + from.surname }}</span>
      <img :src="from.profileimg" class="image-circle">
    </div>
  </div>

  <div v-else class="message">
    <span class="date" v-if="!continuedMessage">{{ dateFormat(message.createdAt, 'ddd dS mmm') }},</span>
    <span class="time" v-if="!continuedMessage">{{ dateFormat(message.createdAt, 'h:MMtt') }}</span>
    <p class="bubble">{{ message.content }}</p>
    <div class="author" v-if="!finalMessage">
      <img :src="from.profileimg" class="image-circle">
      <span class="author-name">{{ from.firstname + ' ' + from.surname }}</span>
    </div>
  </div>

</template>


<script>
import { db } from '@/firebase'
var dateFormat = require('dateformat')

export default {
  name: 'Message',
  props: ['message', 'index', 'allmessages'],
  data () {
    return {
      dateFormat: dateFormat
    }
  },
  firebase () {
    return {
      from: {
        source: db.ref('users/' + this.message.user),
        asObject: true
      }
    }
  },
  computed: {
    continuedMessage () {
      if (this.allmessages[this.index - 1]) {
        if (this.allmessages[this.index - 1].user === this.message.user) {
          return true
        }
      } else {
        return false
      }
    },
    finalMessage () {
      if (this.allmessages[this.index + 1]) {
        if (this.allmessages[this.index + 1].user === this.message.user && !this.continuedMessage) {
          return true
        }
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Message.vue?f7c2f558